import { makeStyles } from '@material-ui/core/styles';
import { ChevronRight } from '@material-ui/icons';
import { createElement } from 'react';
import { TextColors, TextOpacities, SecondaryColors } from '@/utils/constants';
import { encodeSvg, hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: { color: hexToRGBA(TextColors.light, TextOpacities.dark2) },
};

const lightTheme = {
  root: { color: hexToRGBA(TextColors.dark, TextOpacities.light2) },
};

const useStyles = makeStyles(
  ({ breakpoints, transitions }) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      '&.bg-color-blue': {
        backgroundColor: `${SecondaryColors.main} !important`,
      },
      overflow: 'hidden',
      position: 'relative',
      width: '100%',
      display: 'flex',
      alignContent: 'flex-end',
      // maxHeight: '67px',
      padding: 0,
      transition: transitions.create('margin-top', {
        duration: transitions.duration.shortest,
        easing: transitions.easing.easeOut,
      }),

      [breakpoints.up('md')]: {
        justifyContent: 'center',
        alignItems: 'center',
        placeSelf: 'flex-start',
        // maxHeight: '45px',
      },
    },

    content: {
      width: '100%',
    },
  }),
  { name: 'GenBannerRibbon' },
);

export default useStyles;
